export default __webpack_public_path__ + "static/media/Insta.95d833b5.svg";